import { createSelector } from "@ngrx/store";
import { goalsState } from "./goals/state";
import { schoolState } from "./schools/state";
import { metricsState } from "./metrics/state";
import { districtState } from "./district/state";
import { initialGoalsState } from "./goals/reducer";
import { initialDistrictState } from "./district/reducer";
import { initialMetricsState } from "./metrics/reducer";
import { initialSchoolsState } from "./schools/reducer";
import { initialStudentState } from "./students/reducer";
import { studentState } from "./students/state";
import * as _ from "lodash";

export interface AppState {
  goals: goalsState;
  schools: schoolState;
  metrics: metricsState;
  district: districtState;
  students: studentState;
}

export const INITIAL_APPLICATION_STATE: AppState = {
  goals: initialGoalsState,
  schools: initialSchoolsState,
  metrics: initialMetricsState,
  district: initialDistrictState,
  students: initialStudentState,
};

export function getInitialState() {
  return INITIAL_APPLICATION_STATE;
}

export const getGoalsState = (state: AppState) => state.goals;
export const getSchoolsState = (state: AppState) => state.schools;
export const getMetricsState = (state: AppState) => {
  let metrics = _.cloneDeep(state.metrics);
  metrics.allMetrics = _.filter(
    metrics.allMetrics,
    (metric) => !_.defaultTo(metric["visibilityLocked"], false)
  );
  metrics.allMetrics = _.orderBy(
    metrics.allMetrics,
    [
      (metric) =>
        metric.long_name ? metric.long_name.toLowerCase() : metric.long_name,
    ],
    ["asc"]
  );
  return metrics;
};
export const getDistrictState = (state: AppState) => state.district;
export const getStudentsState = (state: AppState) => state.students;
export const getMetrics = (state: AppState) => state.metrics.allMetrics;
export const getMetricById = (id) =>
  createSelector(getMetrics, (metrics) => {
    if (metrics) {
      return _.filter(metrics, { kpi_id: id })[0];
    } else {
      return {};
    }
  });
